import getDefaultState from './moduleSetupState.js'
import mutations from './moduleSetupMutations.js'
import actions from './moduleSetupActions.js'
import getters from './moduleSetupGetters.js'

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
